"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import styles from './Badge.module.scss.mjs';
import clsx from 'clsx';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { Button } from '../Button/Button.mjs';
import '@tabler/icons-react';
import '../Icon/Icon.mjs';
import { IconClose } from '../Icon/components/icons/IconClose.mjs';

const Badge = flowComponent("Badge", (props) => {
  const {
    children,
    className,
    color = "neutral",
    ref,
    onPress,
    onClose,
    isDisabled,
    ...rest
  } = props;
  const rootClassName = clsx(
    styles.badge,
    styles[color],
    isDisabled && styles.disabled,
    className
  );
  const propsContext = {
    Label: {
      elementType: "span",
      className: styles.scope,
      unstyled: true
    },
    Text: {
      elementType: "span",
      className: styles.value
    },
    Button: {
      Label: {
        elementType: "span",
        className: styles.scope,
        unstyled: true
      },
      Text: {
        elementType: "span",
        className: styles.value
      }
    }
  };
  return /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsxs("div", { className: rootClassName, ...rest, ref, children: [
    !onPress && /* @__PURE__ */ jsx("div", { className: styles.content, children }),
    onPress && /* @__PURE__ */ jsx(
      Button,
      {
        isDisabled,
        unstyled: true,
        className: styles.button,
        onPress,
        children
      }
    ),
    onClose && /* @__PURE__ */ jsx(
      Button,
      {
        className: styles.close,
        size: "s",
        color: "dark",
        variant: "plain",
        onPress: onClose,
        isDisabled,
        children: /* @__PURE__ */ jsx(IconClose, {})
      }
    )
  ] }) });
});

export { Badge, Badge as default };
//# sourceMappingURL=Badge.mjs.map
